<template>
    <h4 class="text-center">Pre-assessment</h4>
      <p class="card-text">Before we begin, please take a moment to review the following:</p>
      <form @submit.prevent="submitForm">
        <ul>
          <li><strong>Purpose:</strong> The pre-assignment screening is conducted to assess your qualifications and suitability for the position you have applied for within our organization.</li>
          <li><strong>Information Collection:</strong> During this screening process, we may collect various types of information about you, including but not limited to your educational background, employment history, references, and any additional information relevant to the position.</li>
          <li><strong>Confidentiality:</strong> Any information provided by you or collected during the screening process will be treated as confidential and will only be used for the purpose of evaluating your candidacy for the position.</li>
          <li><strong>Consent:</strong> By participating in this pre-assignment screening, you consent to the collection, use, and disclosure of your personal information for the purposes outlined in this disclosure.</li>
          <li><strong>Accuracy of Information:</strong> You certify that all information provided by you during the screening process is accurate and truthful to the best of your knowledge. Any misrepresentation or falsification of information may result in the termination of your application process or employment, if already hired.</li>
          <li><strong>Data Security:</strong> We take appropriate measures to ensure the security and protection of your personal information in accordance with applicable laws and regulations.</li>
          <li><strong>Access and Correction: </strong>You have the right to access and request corrections to any personal information we hold about you, subject to applicable legal requirements.</li>
          <li><strong>Retention:</strong> Your personal information will be retained only for as long as necessary to fulfill the purposes outlined in this disclosure or as required by law.</li>
          <li><strong>Contact Information:</strong> If you have any questions or concerns about the pre-assignment screening process or this disclosure, please contact HR or your recruiter.</li>
        </ul>
        <div>
          By clicking "I agree" or proceeding with the pre-assignment screening, you confirm that you have read and understood this disclosure and consent to its terms.
        </div>

        <div class="text-center m-3">
          <button type="submit" class="btn btn-primary synchrony-button">I agree</button>
        </div>
      </form>  
</template>
<script>
export default {
  name: 'AssessmentStart',
  emits: ['assessment-started'],
  data() {
    return {
    }
  },
  methods: {
    submitForm() {
        this.$emit('assessment-started');
    }
  }
}
</script>
<style>
.synchrony-button {
  width: 300px;
  padding: 10px;
  background-color: #382d61;
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.synchrony-button:hover {
  background-color: #72018f;
}
</style>